/* eslint-disable */
import React, { useRef, useEffect, useState } from "react";
import Message from "./Message";
import DataTable from "./DataTable";
import TypingIndicator from "./animation/TypingIndicator";
import SourcesModal from "./SourcesModal";
import message from "./Message";

function ChatMessages({
  messages,
  chatId,
  chatInfo,
  newMessageInChatHistory,
  finishedStream,
  loadingAnswer,
  selectedContextValue,
  getDataTable,
  hasError,
  isPatientNotFound,
  getContextMessage,
  scrollToBottom,
  displayPatientSummaryPdfOption = false,
}) {
  const chatWindowRef = useRef(null);
  useEffect(() => {
    scrollToBottom(chatWindowRef);
  }, [messages, scrollToBottom]);

  const showTableContent = () => {
    return (
      !loadingAnswer &&
      selectedContextValue === "taxa_ocupacao_leitos" &&
      !hasError(chatInfo)
    );
  };

  const resumoPacienteChatFinished = () => {
    return (
      !loadingAnswer &&
      selectedContextValue === "resumo_paciente" &&
      messages.length > 1 &&
      !hasError(chatInfo) &&
      !isPatientNotFound(chatInfo)
    );
  };

  const getPatientDashboardMessage = () => {
    const patientId = messages[messages.length - 2]?.content;
    const dashboardPath = `/dashboard/${patientId}`;
    return `Clique no link abaixo para acessar o dashboard do paciente: \n [Dashboard do Paciente](${dashboardPath})`;
  };

  const firstValidAssistantMessageIndex = messages.findIndex(
    (msg) =>
      msg.role === "assistant" &&
      !isPatientNotFound(chatInfo) &&
      msg.content &&
      msg.content.trim() !== "Por favor, envie um número válido."
  );

  const [isModalOpen, setModalOpen] = useState(false);
  const [sourcesData, setSourcesData] = useState([]);

  const getSourcesMessage = (message) => {
    return (
      <>
        Clique aqui para abrir a{" "}
        <span
          className="fonte-destaque"
          onClick={() => {
            setSourcesData(JSON.parse(message.data));
            setModalOpen(true);
          }}
          style={{ color: "#1588C9", cursor: "pointer", fontWeight: 700 }}
        >
          fonte
        </span>{" "}
        dessa pesquisa.
      </>
    );
  };

  const lastMessageWithDataIndex = messages
    .map((m, idx) => {
      let parsedData = [];
      try {
        if (m.data) {
          parsedData = JSON.parse(m.data);
        }
      } catch (e) {
        parsedData = [];
      }
      return {
        hasData: Array.isArray(parsedData) && parsedData.length > 0,
        idx,
      };
    })
    .filter((m) => m.hasData)
    .map((m) => m.idx)
    .pop();

  return (
    <div className="chat-window chat" ref={chatWindowRef}>
      <Message
        content={getContextMessage()}
        role={"assistant"}
        stream={messages.length === 0}
        scrollToBottom={scrollToBottom}
        currentRef={chatWindowRef}
      />

      {messages.map((message, index) => {
        const hasValidData = (() => {
          if (!message.data) return false;
          try {
            const parsed = JSON.parse(message.data);
            return (
              Array.isArray(parsed) &&
              parsed.some(
                (s) => Array.isArray(s.documents) && s.documents.length > 0
              )
            );
          } catch (e) {
            return false;
          }
        })();

        const isLastWithData = index === lastMessageWithDataIndex;

        if (message.content !== undefined) {
          const stream =
            index === messages.length - 1 &&
            (chatId === null || newMessageInChatHistory);

          return (
            <React.Fragment key={index}>
              {message.content && (
                <Message
                  content={message.content}
                  role={message.role}
                  stream={stream}
                  scrollToBottom={scrollToBottom}
                  currentRef={chatWindowRef}
                  messageId={message.id}
                  displayFeedbackOptions={true}
                  messageFeedback={message.feedback}
                  displayPatientSummaryPdfOption={
                    displayPatientSummaryPdfOption &&
                    message.role === "assistant" &&
                    index === firstValidAssistantMessageIndex
                  }
                  patient={messages[0].content}
                />
              )}
              {hasValidData && (!isLastWithData || finishedStream) && (
                <Message
                  customContent={getSourcesMessage(message)}
                  role="assistant"
                  stream={false}
                  scrollToBottom={scrollToBottom}
                  currentRef={chatWindowRef}
                />
              )}
            </React.Fragment>
          );
        }
        return null;
      })}

      {/* finishedStream && resumoPacienteChatFinished() && (
        <Message
          content={getPatientDashboardMessage()}
          role="assistant"
          stream={false}
          scrollToBottom={scrollToBottom}
          currentRef={chatWindowRef}
        />
      ) */}

      {finishedStream && showTableContent() && (
        <DataTable data={getDataTable(chatInfo)} />
      )}

      {finishedStream && loadingAnswer && <TypingIndicator />}
      <SourcesModal
        isOpen={isModalOpen}
        onClose={() => setModalOpen(false)}
        sources={sourcesData}
      />
    </div>
  );
}

export default ChatMessages;
